// For normal metrics, where higher values are better
export const normalMetricMessages = {
    wayDown: [
        'was below your target.',
        'trailed behind your goal.',
        'was below your daily goal.',
    ],
    down: [
        'was a little off the pace.',
        'was a little lower than your goal.',
        'was a bit below your goal.',
        'was within range of your goal.',
    ],
    slightlyDown: [
        'was really close to your goal.',
        'was almost at your goal.',
        'was right under your daily goal.',
        'was super close to your target.',
    ],
    slightlyUp: [
        'was just ahead of your goal.',
        'was right on track.',
        'was above your daily goal.',
        'was ahead of the daily pace.',
    ],
    up: ['was ahead of your goal.'],
    wayUp: ['is crushing it.']
}

// For CPP, since higher CPP is actually not good
export const inverseMetricMessages = {
    wayDown: ['is crushing it.'],
    down: [
        'was better than your goal.',
        'was below your goal.',
    ],
    slightlyDown: [
        'was a little better than your pace.',
        'was just better than your goal.',
        'was super close to your target.',
    ],
    slightlyUp: [
        'was really close to your goal.',
        'was right on track.',
        'was right above your daily goal.',
        'was just above your daily pace.',
    ],
    up: [
        'was a little off the pace.',
        'was a little higher than your goal.',
        'was a bit above your goal.',
        'was within range of your goal.',
    ],
    wayUp: [
        'was off your target.',
        'was above your daily goal.',
    ]
}